import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { useEffect, useState } from 'react';
import { useSite } from '../context/site';
import { NAME } from '../shared';

function ServiceTypeGroupDropdown({ serviceTypeGroupId, onChange, multi }) {
    const { lists } = useSite();

    const [serviceTypeGroup, setServiceTypeGroup] = useState(serviceTypeGroupId || '');
    const [serviceTypeGroups, setServiceTypeGroups] = useState([]);
    const [serviceTypeGroupsLoaded, setServiceTypeGroupsLoaded] = useState(false);

    const [selectedServiceTypes, setSelectedServiceTypes] = useState(null);

    const serviceTypeGroupOptionTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div className={!option.active ? 'text-red-500' : ''}>{option.itemName}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const selectedServiceTypeGroupTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div className={!option.active ? 'text-red-500' : ''}>{option.itemName}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const panelFooterTemplate = () => {
        const length = selectedServiceTypes ? selectedServiceTypes.length : 0;

        return (
            <div className="py-2 px-3">
                <b>{length}</b> item{length > 1 ? 's' : ''} selected.
            </div>
        );
    };

    useEffect(() => {
        if (serviceTypeGroup) {
            if (!!multi === false) {
                onChange(serviceTypeGroup);
            }
        }
    }, [serviceTypeGroup, onChange, multi]);

    useEffect(() => {
        if (!!multi === false) {
            return;
        }

        if (selectedServiceTypes) {
            onChange(selectedServiceTypes.map((x) => x._id));
        }
    }, [multi, selectedServiceTypes, onChange]);

    useEffect(() => {
        if (Array.isArray(lists) && lists.length > 0 && !serviceTypeGroupsLoaded) {
            const validServiceTypes = [NAME.listType.serviceTypeGroup];
            const _serviceTypeGroups = serviceTypeGroupId
                ? lists.filter((l) => validServiceTypes.includes(l.listType))
                : lists.filter((l) => l.active && validServiceTypes.includes(l.listType));

            setServiceTypeGroups(_serviceTypeGroups);
            setServiceTypeGroupsLoaded(true);

            setServiceTypeGroup(
                serviceTypeGroupId
                    ? serviceTypeGroupId
                    : _serviceTypeGroups.find((g) => g.itemIsDefault)._id
            );
        }
    }, [lists, serviceTypeGroupId, serviceTypeGroupsLoaded]);

    if (!!multi) {
        return (
            <>
                <MultiSelect
                    filter
                    value={selectedServiceTypes}
                    options={serviceTypeGroups}
                    onChange={(e) => setSelectedServiceTypes(e.value)}
                    optionLabel="itemName"
                    placeholder="Select Service Types"
                    itemTemplate={serviceTypeGroupOptionTemplate}
                    panelFooterTemplate={panelFooterTemplate}
                    className="w-20rem"
                    display="chip"
                />

                <br />
                <br />

                {!selectedServiceTypes ? null : (
                    <>
                        <h2>
                            {selectedServiceTypes.length === serviceTypeGroups.length
                                ? `All ${selectedServiceTypes.length} `
                                : selectedServiceTypes.length}{' '}
                            Selected Service Types
                        </h2>

                        {selectedServiceTypes.length === serviceTypeGroups.length ? (
                            <p>All</p>
                        ) : (
                            <ul>
                                {selectedServiceTypes &&
                                    selectedServiceTypes.map((x, i) => {
                                        return <li key={i}>{x.itemName}</li>;
                                    })}
                            </ul>
                        )}
                    </>
                )}
            </>
        );
    }

    return (
        <Dropdown
            filter
            value={serviceTypeGroup}
            valueTemplate={selectedServiceTypeGroupTemplate}
            onChange={(e) => setServiceTypeGroup(e.value)}
            options={serviceTypeGroups.sort((a, b) => (a.itemName > b.itemName ? 1 : -1))}
            itemTemplate={serviceTypeGroupOptionTemplate}
            optionLabel="itemName"
            optionValue="_id"
            placeholder="Select a Service Type"
        />
    );
}

export default ServiceTypeGroupDropdown;
